import { Modal } from 'react-bootstrap';
import { BasicPopup } from '../../Common/basicPopup/BasicPopup';
import { useState } from 'react';

export const ConfirmationPopup = (props) => {
  const [showBasicPopup, setShowBasicPopup] = useState(false);
  // console.log(props)
  return (
    <>
      <Modal
        show={props.showConfirm}
        onHide={() => {
          props.onConfirmHide();
        }}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header
          className="modal-header px-8 pt-8 pb-0"
          closeButton
          style={{
            borderBottom: '#fff',
            margin: '0%',
            alignItems: 'flex-start',
          }}
        >
          <Modal.Title>
            <div className="fw-bolder">
              {' '}
              {props?.headerText} {props.showConfirm}
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          className="px-8 pb-0 modal-body"
          style={{ borderBottom: '#fff', margin: '0%', paddingTop: '0.625rem' }}
        >
          <p style={{ marginBottom: '2.625rem' }}>{props?.modalBody}</p>
        </Modal.Body>
        <Modal.Footer
          className="pt-0 px-8 pb-8 modal-footer"
          style={{ borderTop: '#fff', margin: '0%' }}
        >
          {/* <div className='m-6 float-end'> */}
          <button
            type="button"
            className="customTable action-btn btn btn-primary btn-hover-color"
            style={{ marginRight: '0.75rem' }}
            onClick={() => {
              props.onConfirmHide();
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            className="customTable action-btn btn btn-primary btn-hover-color m-0"
            onClick={() => {
              setShowBasicPopup(true);
              props.onConfirmHide();
              props.onConfirmStatus();
            }}
          >
            {props?.otherBtnText}
          </button>
          {/* </div> */}
        </Modal.Footer>
      </Modal>

      <BasicPopup
        show={showBasicPopup && props.checkError === false}
        onHide={() => setShowBasicPopup(false)}
        popupTitle={
          props?.headerText?.includes('Employee Active Inactive')
            ? `Employee Marked ${props?.activeToggle ? 'active' : 'inactive'} Successfully`
            : props?.headerText?.includes('Send Invitation')
              ? 'Invitation sent to selected employees successfully'
              : props?.headerText?.includes('Employee Role Change')
                ? 'Role Changed Successfully'
                : `Enterprise Marked ${props?.activeToggle ? 'active' : 'inactive'} Successfully`
        }
        popupSubTitle="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
        otherButtonText=""
        onConfirmStatus={() => {
          setShowBasicPopup(false);
          if (props.toggle === true) {
            window.location.href = '/enterprise/enterprise-admin/dashboard';
          }
        }}
      />
    </>
  );
};
